import React from 'react';
import { cn } from '@/lib/utils';

interface FilterBarProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * FilterBar — Componente oficial do Design System NetUno.
 * Container padronizado para grupos de filtros (Select, Input, DatePicker).
 * Proibido criar barras de filtro manuais fora deste componente.
 */
export const FilterBar: React.FC<FilterBarProps> = ({
  children,
  className,
}) => (
  <div className={cn(
    'flex items-center gap-2 flex-wrap p-3 rounded-xl border bg-card',
    className,
  )}
  style={{ boxShadow: 'var(--shadow-card)' }}
  >
    {children}
  </div>
);

export default FilterBar;
